import type { ReactNode } from 'react'
import { useFeatureFlags, type FeatureFlags } from '../../hooks/useFeatureFlags'
import ForbiddenPage from '../../pages/ForbiddenPage'

interface RequireFeatureProps {
  flag: keyof FeatureFlags
  children: ReactNode
}

/**
 * Route guard: renders children only when a runtime feature flag is on,
 * otherwise a clean 403. Mirrors the backend requireFeature gate so a deep link
 * to a gated-off page (e.g. WhatsApp Blast) never renders. Renders nothing until
 * the flag has loaded, so an enabled feature does not flash a 403 first.
 */
export default function RequireFeature({ flag, children }: RequireFeatureProps) {
  const { flags, loaded } = useFeatureFlags()
  if (!loaded) {
    return null
  }
  if (!flags[flag]) {
    return <ForbiddenPage />
  }
  return <>{children}</>
}
